import request from './axios';

/**
 * 获取新闻列表
 * @param {Object} params 查询参数
 * @param {Number} params.page 页码
 * @param {Number} params.pageSize 每页条数
 * @param {Number} params.category 分类ID
 * @returns {Promise<Object>} 返回新闻列表和总数
 */
export function getNewsList(params) {
  return request({
    url: '/webapi/news/list',
    method: 'get',
    params
  });
}

/**
 * 获取新闻详情
 * @param {String} id 新闻ID
 * @returns {Promise<Object>} 返回新闻详情
 */
export function getNewsDetail(id) {
  return request({
    url: `/webapi/news/list/${id}`,
    method: 'get'
  });
}

/**
 * 获取热门新闻
 * @param {Object} params 查询参数
 * @param {Number} params.limit 限制条数
 * @param {Number} params.category 分类ID
 * @returns {Promise<Object>} 返回热门新闻列表
 */
export function getHotNews(params) {
  return request({
    url: '/webapi/news/toplist',
    method: 'get',
    params
  });
}

/**
 * 获取新闻分类
 * @returns {Promise<Object>} 返回新闻分类列表
 */
export function getNewsCategories() {
  return request({
    url: '/webapi/news/categories',
    method: 'get'
  });
} 